const REQUIRED_USER_DETAILS = ["user", "company"];

/**
 * Guarda la sesión en sessionStorage.
 *
 * `JSON.stringify(undefined)` devuelve `undefined` y `setItem` lo coacciona a la
 * cadena "undefined": el `JSON.parse` que la lee después truena con
 * `"undefined" is not valid JSON` y tira la app al montar. Por eso se valida ANTES
 * de escribir nada — un `/users` que no traiga usuario o compañía debe fallar aquí,
 * en el login, donde el error es visible y accionable, y no dejar media sesión
 * guardada.
 */
export const saveUserSession = (userDetails, session) => {
  const missing = REQUIRED_USER_DETAILS.filter((key) => !userDetails?.[key]);

  if (missing.length > 0) {
    throw new Error(
      `Respuesta de /users incompleta: falta ${missing.join(" y ")}. No se inició sesión.`,
    );
  }

  sessionStorage.setItem("auth", true);
  sessionStorage.setItem("jwt", session.signInUserSession.idToken.jwtToken);
  sessionStorage.setItem("user", JSON.stringify(userDetails.user));
  sessionStorage.setItem("company", JSON.stringify(userDetails.company));

  // `getUserDetails` hoy solo retorna { user, company }, así que sin esta guarda la
  // clave quedaba siempre con la cadena "undefined". Nadie la lee todavía, pero se
  // guarda solo cuando el endpoint la mande de verdad.
  if (userDetails.merchantsCategories !== undefined) {
    sessionStorage.setItem(
      "merchantsCategories",
      JSON.stringify(userDetails.merchantsCategories),
    );
  }
};

export const clearCaches = () => {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
};
